import React, { useState, useEffect, useCallback } from "react";
import {
  Row,
  Col,
  Pagination,
  Collapse,
  Form,
  Button,
  Input,
  message,
  Select,
  Table,
} from "antd";
import axios from "axios";
import PageHeader from "../Layout/PageHeader";
import NewsFilters from "./NewsFilters";
import { CaretRightOutlined } from "@ant-design/icons";
import { formatDateTime } from "../../helpers/date";

const News = () => {
  const [pagination, setPagination] = useState({ currentPage: 1, limit: 10 });
  const [news, setNews] = useState([]);
  const [filters, setFilters] = useState({
    isActive: null,
  });
  const [newsType, setNewsType] = useState("blog");

  const [loading, setLoading] = useState({
    index: false,
    create: false,
  });
  const [form] = Form.useForm();

  const updateIsActiveStatus = async (row, value) => {
    await axios
      .patch("/api/news/status", {
        id: row.objectId,
        isActive: value,
      })
      .then((res) => {
        message.info(
          `News status updated to ${value ? "active" : "inactive"}`
        );
      })
      .catch((error) => {
        message.error(error.message);
      });
  };

  const fetchNotification = useCallback(async () => {
    setLoading((prevLoading) => ({ ...prevLoading, index: true }));

    const params = {
      ...(filters.isActive !== null && { isActive: filters.isActive }),
      limit: pagination.limit,
      page: pagination.currentPage,
    };

    const res = await axios.get("/api/news", { params });

    setNews(res.data.data);
    setPagination(res.data.pagination);
    setLoading((prevLoading) => ({ ...prevLoading, index: false }));
  }, [pagination.currentPage, pagination.limit, filters]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      width: 300,
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 110,
    },
    {
      title: "link",
      dataIndex: "link",
    },
    {
      title: "Active",
      dataIndex: "isActive",
      width: 130,
      render: (text, row) => {
        return (
          <div>
            <Select
              value={text}
              className="select-before"
              width="250px"
              onChange={(value) => updateIsActiveStatus(row, value)}
            >
              <Select.Option value={true}>Yes</Select.Option>
              <Select.Option value={false}>No</Select.Option>
            </Select>
          </div>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      width: 160,
      render: (createdAt) => formatDateTime(createdAt),
    },
  ];

  useEffect(() => {
    fetchNotification();
  }, [pagination.currentPage, pagination.limit, fetchNotification]);

  const createHandler = async (newNotification) => {
    setLoading((prevLoading) => ({ ...prevLoading, create: true }));

    try {
      await axios.post("/api/news", {
        ...newNotification,
      });

      form.resetFields();
      message.success("News created");
      fetchNotification();
    } catch (error) {
      message.error(error.response?.data.message || error.message);
    }

    setLoading((prevLoading) => ({ ...prevLoading, create: false }));
  };

  return (
    <div>
      <PageHeader
        title="News"
        childRoutes={[{ path: "/news", breadcrumbName: "News" }]}
      />

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Create New News" key="create-news-section">
          <Form
            form={form}
            name="new-news-form"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            autoComplete="off"
            onFinish={createHandler}
          >
            <Form.Item label="Title" name="title" rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item
              label="Type"
              name="type"
              rules={[{ required: true }]}
            >
              <Select value={newsType} onChange={setNewsType}>
                <Select.Option value="blog">Blog</Select.Option>
                <Select.Option value="promotion">Promotion</Select.Option>
                <Select.Option value="announcement">Announcement</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="Link" name="link" rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button loading={loading.create} type="primary" htmlType="submit">
                Create
              </Button>
            </Form.Item>
          </Form>
        </Collapse.Panel>
      </Collapse>
      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Filters" key="filters">
          <NewsFilters
            filters={filters}
            onFiltersChange={(filters) => setFilters(filters)}
          />
        </Collapse.Panel>
      </Collapse>

      <Row justify="end">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>

      <Table
        rowKey="notificationId"
        pagination={false}
        columns={columns}
        dataSource={news}
        loading={loading.index}
        scroll={{x: 1000, y: 500}}
      />

      <Row justify="end">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default News;
